const HDIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.89106 4.21045H18.3355C19.3133 4.21045 20.1133 5.01045 20.1133 5.98823V18.4327C20.1133 19.4104 19.3133 20.2104 18.3355 20.2104H5.89106C4.90439 20.2104 4.11328 19.4104 4.11328 18.4327V5.98823C4.11328 5.01045 4.90439 4.21045 5.89106 4.21045ZM9.89105 14.2104C9.89105 14.5749 10.1933 14.8771 10.5577 14.8771C10.9222 14.8771 11.2244 14.5749 11.2244 14.2104V10.2104C11.2244 9.84599 10.9222 9.54377 10.5577 9.54377C10.1933 9.54377 9.89105 9.84599 9.89105 10.2104V11.766H8.11327V10.2104C8.11327 9.84599 7.81105 9.54377 7.4466 9.54377C7.08216 9.54377 6.77994 9.84599 6.77994 10.2104V14.2104C6.77994 14.5749 7.08216 14.8771 7.4466 14.8771C7.81105 14.8771 8.11327 14.5749 8.11327 14.2104V13.0993H9.89105V14.2104ZM13.4466 9.54377H16.5577C17.0466 9.54377 17.4466 9.94377 17.4466 10.4327V13.9882C17.4466 14.4771 17.0466 14.8771 16.5577 14.8771H13.4466C13.1977 14.8771 13.0022 14.6815 13.0022 14.4327V9.98821C13.0022 9.73933 13.1977 9.54377 13.4466 9.54377ZM16.1133 13.5438H14.3355V10.8771H16.1133V13.5438Z"
        fill="white"
      />
    </svg>
  );
};
export default HDIcon;
